interface IconProps {
  className?: string;
}

/** Chevron glyph from the DubaiExpress product page mockup (inline links). */
const ChevronRightIcon = ({ className }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    className={className}
  >
    <path d="m9 18 6-6-6-6" />
  </svg>
);

export default ChevronRightIcon;
